<template>
  <section class="card mgt-20px">
    <header class="header-card">
      <p>{{ $t('addEditFournisseurs.coordonee.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field :label="$t('addEditFournisseurs.coordonee.telephone')">
            <b-input v-model="fournisseur.telephone"></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('addEditFournisseurs.coordonee.telephonePortable')">
            <b-input v-model="fournisseur.portable"></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <input-email
            v-model="fournisseur.email"
            :label="$t('addEditFournisseurs.coordonee.email')"/>
        </div>
        <div class="column is-6">
          <input-url
            v-model="fournisseur.siteWeb"
            :label="$t('addEditFournisseurs.coordonee.siteInternet')"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputUrl from '@/components/general/inputUrl';
import InputEmail from '@/components/general/inputEmail';

export default {
  name: 'CoordonneesFournisseurs',
  props: {
    fournisseur: {
      type: Object,
      required: true,
    },
  },
  components: {
    InputUrl,
    InputEmail,
  },
};
</script>
